export default __webpack_public_path__ + "static/media/service4.d3d41844.png";